import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";

function KeyPersonWiseView({ rowData, setShowGraph }) {
  const navigate = useNavigate();
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [counterExpense, setCounterExpense] = useState({});

  // Updated color map
  const colorMap = {
  gift: "#757E7F",         // SO Pop
  meeting: "#FFDB58",      // Meeting
  branding: "#F9A8A2",     // Branding
  other: "#96D389",        // Other
  personalGift: "#BEBFC5", // Direct Pop
  sales: "#77B2E8",        // Sales
};


  useEffect(() => {
    if (rowData) getExpenses(rowData.key_person);
  }, [rowData]);

  const getExpenses = (key_person) => {
    utils
      .callAPI(
        "get",
        `meeting/counter/view-key-person-wise?key_persion_id=${key_person}&counter_id=`
      )
      .then((res) => setCounterExpense(res || {}))
      .catch(() => setCounterExpense({}));
  };

  // Field mapping FIXED
  const expenseItems = [
    { key: "gift", label: "SO Pop", field: "gift_amt" },
    { key: "meeting", label: "Meeting", field: "meeting_amt" },
    { key: "branding", label: "Branding", field: "brand_amt" }, // FIXED
    { key: "other", label: "Other", field: "other_amt" },
    { key: "personalGift", label: "Direct Pop", field: "popup_amt" },
    { key: "sales", label: "Sales", field: "sales_amt" },
  ];

  useEffect(() => {
    if (chartRef.current && counterExpense) {
      const ctx = chartRef.current.getContext("2d");

      if (chartInstance.current) chartInstance.current.destroy();

      // Correct graph data order
      const dataValues = expenseItems.map((item) =>
        parseFloat(counterExpense[item.field] || 0)
      );

      chartInstance.current = new Chart(ctx, {
        type: "pie",
        data: {
          labels: expenseItems.map((item) => item.label),
          datasets: [
            {
              label: "Amount",
              data: dataValues,
              backgroundColor: expenseItems.map(
                (item) => colorMap[item.key]
              ),
              borderColor: "#ffffff",
              borderWidth: 2,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: { display: false },
            legend: { display: true, position: "bottom" },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (tooltipItem) {
                  const value = tooltipItem.raw;
                  return `${tooltipItem.label}: ₹${value.toLocaleString()}`;
                },
              },
            },
          },
        },
        plugins: [ChartDataLabels],
      });
    }

    return () => {
      if (chartInstance.current) chartInstance.current.destroy();
    };
  }, [counterExpense]);

  const handleBack = () => setShowGraph(false);
  const handleNavigate = (type) =>
    navigate(
      `/marketing/keyPerson-wise-detail/${rowData?.key_person}?type=${type}`
    );

  const ColorDot = ({ color }) => (
    <span
      style={{
        display: "inline-block",
        width: "14px",
        height: "14px",
        backgroundColor: color,
        marginRight: "8px",
      }}
    ></span>
  );

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <h5>{rowData?.emp_name}</h5>
          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={handleBack}>
              Close
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <Row>
            {/* Chart */}
            <Col
              md={4}
              className="d-flex flex-column justify-content-center align-items-center"
            >
              <div
                className="w-100 d-flex justify-content-center"
                style={{ height: "300px" }}
              >
                <canvas ref={chartRef}></canvas>
              </div>
              <p className="text-muted mt-2">
                *Note: Hover over the chart segments to view details
              </p>
            </Col>

            {/* Expense Breakdown */}
            <Col md={8} className="d-flex flex-column">
              <h6 className="fw-bold text-secondary pb-2 border-bottom">
                Expense Break-up
              </h6>

              {expenseItems.map((item) => (
                <p
                  key={item.key}
                  onClick={() => handleNavigate(item.key)}
                  style={{
                    fontSize: "1.1rem",
                    color: "black",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  <ColorDot color={colorMap[item.key]} />
                  {item.label} Amount = ₹
                  {parseFloat(counterExpense[item.field] || 0).toLocaleString()}
                  /-
                </p>
              ))}

              <hr />

              <h5 className="fw-bold">
                Total Marketing Expense = ₹
                {parseFloat(counterExpense.total_amt || 0).toLocaleString()}/-
              </h5>

              <h5 className="fw-bold">
                Total Sales = ₹
                {parseFloat(counterExpense.sales_amt || 0).toLocaleString()}/-
              </h5>

              <h5
                className="fw-bold"
                style={{
                  color:
                    parseFloat(counterExpense.total_percent || 0) >= 3
                      ? "red"
                      : "green",
                }}
              >
                Budget Percentage ={" "}
                {(parseFloat(counterExpense.total_percent || 0) || 0).toFixed(
                  2
                )}
                %
              </h5>
            </Col>
          </Row>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default KeyPersonWiseView;
